module.exports = __webpack_public_path__ + "static/img/jiditit2.7f4b8461.png";